import axios from 'axios';

const apiCnpj = axios.create({
  baseURL: 'https://www.sintegraws.com.br/api/v1',
});

export default apiCnpj;
